export default __webpack_public_path__ + "static/media/square-o-icon.a3d78b8b.svg";